import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo4/chinos.png";
import Imagen2 from "../../../images/modulo4/latinos.png";
import Imagen3 from "../../../images/modulo4/angloparlantes.png";
import Imagen4 from "../../../images/modulo4/estadosunidos.png";
import Imagen5 from "../../../images/modulo4/china.png";
import Imagen6 from "../../../images/modulo4/mexico.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faComments } from "@fortawesome/free-solid-svg-icons";
import { modulo4 } from "../../../routes/Module4";
import Sidebar from "../Sidebar";
import Card from "../../../components/Card";
import InputText from "../../../components/InputText";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo4/Actividad 5.mp3";

const Actividad5 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "I" },
    ans2: { value: "", valid: "", correctValue: "M" },
    ans3: { value: "", valid: "", correctValue: "E" },
  });
  const infoUnidad = modulo4.content[0];
  const infoAct = modulo4.content[0].activities[4];
  const crumbs = [
    {
      title: modulo4.title,
      url: "/" + modulo4.url,
    },
    {
      title:
        modulo4.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo4.content[0].activities[5].name}`,
    linkNext: `${modulo4.url}/${modulo4.content[0].path}/${modulo4.content[0].activities[5].path}`,
    titlePrev: `${modulo4.content[0].activities[3].name}`,
    linkPrev: `${modulo4.url}/${modulo4.content[0].path}/${modulo4.content[0].activities[3].path}`,
  };
  const metadata = {
    color: modulo4.color,
    title: `${modulo4.title} - ${infoAct.name}`,
    name: modulo4.title,
  };
  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"] === answers[key]["value"].toUpperCase()
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...answers, newAnswers });
  };
  const handleAnswers = (event, name) => {
    event.preventDefault();
    setAnswers({
      ...answers,
      [name]: { ...answers[name], value: event.target.value },
    });
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo4.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">Actividad 5</h2>
      <AudioPlayer track={Audio} />

      <ul>
        <li>
          En el mundo se hablan muchos idiomas.
        </li>
        <li>
          Coloca la letra inicial de cada idioma en el país donde tiene más
          hablantes.
        </li>
      </ul>

      <div className="row my-5 align-items-center">
        <div className="col-lg-4 col-md-6 col-12">
          <div className="my-1 d-flex align-items-start flex-column">
            <div className={`bg-${modulo4.color} circle-option me-3`}>M</div>
            <img src={Imagen1} alt="Familia" className="img-fluid img-80" />
            <Card>El mandarín es el idioma más hablado del mundo.</Card>
          </div>
          <div className="my-1 d-flex align-items-start flex-column">
            <div className={`bg-${modulo4.color} circle-option me-3`}>E</div>
            <img src={Imagen2} alt="Familia" className="img-fluid img-80" />
            <Card>
              <span className="">
                El segundo idioma más hablado es el español.
              </span>
            </Card>
          </div>
          <div className="my-1 d-flex align-items-start flex-column">
            <div className={`bg-${modulo4.color} circle-option me-3`}>I</div>
            <img src={Imagen3} alt="Familia" className="img-fluid img-80" />
            <Card>
              <span className="">
                El inglés es hablado por 360 millones de personas.
              </span>
            </Card>
          </div>
        </div>
        <div className="col-lg-5 offset-lg-2 offset-0 col-md-6 col-12">
          <Card>
            <div className="d-flex flex-column">
              <InputText
                answer={answers.ans1}
                onChangeInput={handleAnswers}
                name="ans1"
              />
              <img src={Imagen4} alt="Familia" className="img-fluid" />
            </div>
          </Card>

          <Card>
            <div className="d-flex flex-column">
              <InputText
                answer={answers.ans2}
                onChangeInput={handleAnswers}
                name="ans2"
              />
              <img src={Imagen5} alt="Familia" className="img-fluid" />
            </div>
          </Card>
          <Card>
            <div className="d-flex flex-column">
              <InputText
                answer={answers.ans3}
                onChangeInput={handleAnswers}
                name="ans3"
              />
              <img src={Imagen6} alt="Familia" className="img-fluid" />
            </div>
          </Card>

          <div className="d-flex w-100 justify-content-end my-4">
            <button
              className={`btn btn-${modulo4.color}`}
              onClick={validateAnswers}
            >
              Enviar respuestas
            </button>
          </div>
        </div>
      </div>
      <ul>
        <li>Ahora conversa con tu compañero, compañera o familiar.</li>
      </ul>
      <div>
        ¿En qué otros países se habla español? ¿En qué otros países se habla
        inglés?
      </div>
      <textarea className="form-control mt-1 mb-3" rows={3} />
      <div className="">
        ¿Sería bueno que todas las personas habláramos el mismo idioma? ¿Por
        qué?
      </div>
      <textarea className="form-control mt-1 mb-3" rows={3} />

      <GuiaDocente>
        <p>
          Lea las indicaciones. Lea la información de los recuadros y observen
          las ilustraciones. Ayude a resolver la actividad. Luego, dialoguen
          sobre las preguntas finales. Destaque que la diversidad es valiosa
          pero que es muy útil compartir un idioma para entenderse.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad5;
